@switch (specificTemplateName) {
  @case (departmentTableNamesEnum.ContactPersonList) {
    <app-contact-person-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
      [hideButtons]="hideButtons"
    ></app-contact-person-template>
  }
  @case (departmentTableNamesEnum.MainEngineList) {
    <app-engine-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
      [hideButtons]="hideButtons"
    ></app-engine-template>
  }
  @case (departmentTableNamesEnum.CargoHoldList) {
    <app-cargo-hold-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
      [hideButtons]="hideButtons"
    ></app-cargo-hold-template>
  }
  @case (departmentTableNamesEnum.CargoGearList) {
    <app-cargo-gear-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
      [hideButtons]="hideButtons"
    ></app-cargo-gear-template>
  }
  @default {
    <app-departments-template
      [columnName]="columnName"
      [element]="element"
    ></app-departments-template>
  }
}
